<div class="usb-carousel position-relative"
     (mouseenter)="onMouseEnter()"
     (mouseleave)="onMouseLeave()">

  <ng-container *ngIf="showArrows">
    <ng-container *ngIf="prevArrowTemplate; else defaultPrevArrow">
      <ng-container *ngTemplateOutlet="prevArrowTemplate; context: { prev: carousel.prev.bind(carousel) }"></ng-container>
    </ng-container>
    <ng-template #defaultPrevArrow>
      <button type="button" class="usb-carousel-arrow usb-carousel-arrow-left" (click)="carousel.prev()" aria-label="Anterior">
        <i class="bi bi-chevron-left"></i>
      </button>
    </ng-template>
  </ng-container>

  <div class="usb-carousel-viewport">
    <div class="usb-carousel-track"
         [style.width.%]="carousel.trackWidthPercent"
         [style.transform]="'translateX(' + carousel.translatePercent + '%)'"
         [style.transition]="carousel.transitionEnabled ? 'transform 0.7s ease' : 'none'">
      <div class="usb-carousel-slide"
           *ngFor="let slide of carousel.extended; trackBy: trackBySlide"
           [style.width.%]="carousel.slideWidthPercent">
        <ng-container *ngTemplateOutlet="slideTemplate; context: { $implicit: slide.data, index: slide.realIndex }"></ng-container>
      </div>
    </div>
  </div>

  <ng-container *ngIf="showArrows">
    <ng-container *ngIf="nextArrowTemplate; else defaultNextArrow">
      <ng-container *ngTemplateOutlet="nextArrowTemplate; context: { next: carousel.next.bind(carousel) }"></ng-container>
    </ng-container>
    <ng-template #defaultNextArrow>
      <button type="button" class="usb-carousel-arrow usb-carousel-arrow-right" (click)="carousel.next()" aria-label="Siguiente">
        <i class="bi bi-chevron-right"></i>
      </button>
    </ng-template>
  </ng-container>

</div>
